import React from "react";
import CustomModalLayout from "../../../../../web/Auth/CustomModalLayout";
import { Button } from "../../../../../../shadcn/components/ui/button";

export interface KYCRequestRedirectNotificationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
  title?: string;
  description?: string;
  cancelLabel?: string;
  continueLabel?: string;
}

const KYCRequestRedirectNotificationModal = ({
  open,
  onClose,
  onConfirm,
  title = "Redirecting to Digio for KYC",
  description = "You're about to be redirected to our trusted KYC partner, Digio, to complete your verification process. Please make sure to follow all the steps carefully. Once the verification is complete, you'll be automatically redirected back to Auction Bazaar.",
  cancelLabel = "Cancel",
  continueLabel = "Continue",
}: KYCRequestRedirectNotificationModalProps) => {
  const handleContinue = async () => {
    await onConfirm();
    onClose();
  };

  return (
    <CustomModalLayout
      open={open}
      onClose={onClose}
      childrenClassName="pb-6 px-6 lg:px-8 overflow-y-scroll"
      className="pt-8 lg:pb-[30px] mx-4  max-h-[calc(100%-10px)]"
    >
      <div className="flex flex-col justify-between min-h-[243px]">
        <div className="flex flex-col gap-4">
          <h2 className="font-semibold text-lg text-brand-textBlack text-center">
            {title}
          </h2>
          <p className="text-sm text-brand-textBlack text-center">
            {description}
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 mt-6">
          <Button variant="outline" className="flex-1" onClick={onClose}>
            {cancelLabel}
          </Button>
          <Button variant="default" className="flex-1" onClick={handleContinue}>
            {continueLabel}
          </Button>
        </div>
      </div>
    </CustomModalLayout>
  );
};

export default KYCRequestRedirectNotificationModal;
